<script setup>

import {useUserStore} from "@/stores/user.store";
import {storeToRefs} from "pinia/dist/pinia";

const userStore = useUserStore();
userStore.fetchUser();
const {user} = storeToRefs(userStore);

const updateUser = async () => {
  await userStore.updateUserName();
}

</script>

<template>
  <van-form @submit="updateUser">
    <van-cell-group inset>
      <van-field
          v-model="user.first_name"
          label="First Name"
          placeholder="First Name"
          required
          :rules="[{ required: true, message: 'Please input your first name' }]"
      />
      <van-field
          v-model="user.last_name"
          label="Last Name"
          placeholder="Last Name"
          required
          :rules="[{ required: true, message: 'Please input your last name' }]"
      />
      <van-field
          v-model="user.nickname"
          label="Nickname"
          placeholder="Nickname"
          required
          :rules="[{ required: true, message: 'Please input your nickname' }]"
      />
    </van-cell-group>
    <van-divider/>
    <van-cell-group inset>
      <van-button block round type="success" native-type="submit">
        Update
      </van-button>
    </van-cell-group>
  </van-form>
</template>
